import { createFileRoute } from "@tanstack/react-router";
import { AdminDashboardShell } from "@/components/layout/AdminDashboardShell";
import { ReclaimOpsPage } from "@/features/reclaim-ops";
import { reclaimsSearchSchema } from "@/features/reclaim-ops/reclaim-route-search";

/**
 * Route: /reclaims (not /returns). Reclaim covers trial returns + RMA +
 * carrier scans + warehouse receipts + refurb QC + scrap + charge-off.
 *
 * `?reclaimId=` deep-links a row's detail drawer, mirroring `/users?userId=`.
 */
export const Route = createFileRoute("/reclaims/")({
  validateSearch: reclaimsSearchSchema,
  component: ReclaimsRoute,
});

function ReclaimsRoute() {
  return (
    <AdminDashboardShell>
      <ReclaimOpsPage />
    </AdminDashboardShell>
  );
}
